import React, { useState } from 'react';
import { FaBolt, FaTools, FaHardHat, FaHome, FaBuilding, FaPhone, FaEnvelope, FaMapMarkerAlt, FaStar, FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Home = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Form submission logic would go here
    alert('Thank you for contacting us! We will get back to you shortly.');
    setFormData({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div className="min-h-screen bg-light">
      {/* Navigation */}
      <nav className="bg-secondary text-white py-4">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div className="flex items-center">
            <FaBolt className="text-primary text-3xl mr-2" />
            <div>
              <span className="font-bold text-xl">PowerPro Electrical</span>
              <div className="text-xs text-primary">Demo Site by <a href="https://cloudnext.dev" target="_blank" rel="noopener noreferrer" className="hover:underline">CloudNext</a></div>
            </div>
          </div>
          
          <div className="hidden md:flex space-x-8">
            <a href="#home" className="hover:text-primary transition">Home</a>
            <a href="#services" className="hover:text-primary transition">Services</a>
            <a href="#about" className="hover:text-primary transition">About</a>
            <a href="#testimonials" className="hover:text-primary transition">Testimonials</a>
            <a href="#contact" className="hover:text-primary transition">Contact</a>
          </div>
          
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-white focus:outline-none">
            <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path fillRule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z" />
              ) : (
                <path fillRule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2z" />
              )}
            </svg>
          </button>
        </div>
        
        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden bg-dark mt-2 py-3 px-4">
            <div className="flex flex-col space-y-3">
              <a href="#home" className="hover:text-primary transition" onClick={() => setIsMenuOpen(false)}>Home</a>
              <a href="#services" className="hover:text-primary transition" onClick={() => setIsMenuOpen(false)}>Services</a>
              <a href="#about" className="hover:text-primary transition" onClick={() => setIsMenuOpen(false)}>About</a>
              <a href="#testimonials" className="hover:text-primary transition" onClick={() => setIsMenuOpen(false)}>Testimonials</a>
              <a href="#contact" className="hover:text-primary transition" onClick={() => setIsMenuOpen(false)}>Contact</a>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section id="home" className="hero-pattern py-20 md:py-32">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 text-center md:text-left text-white mb-10 md:mb-0">
              <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-4">
                <span className="text-primary">Reliable</span> Electrical Services For Your Home & Business
              </h1>
              <p className="text-xl mb-8 text-gray-300">
                Professional, licensed electricians providing safe and dependable electrical solutions across Australia. Fully compliant with Australian Standards.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
                <a href="#contact" className="bg-primary text-secondary font-bold py-3 px-8 rounded-lg shadow-lg hover:bg-yellow-500 transition cta-button text-center">
                  Get Free Quote
                </a>
                <a href="tel:+61412345678" className="bg-white text-secondary font-bold py-3 px-8 rounded-lg shadow-lg hover:bg-gray-100 transition text-center flex items-center justify-center">
                  <FaPhone className="mr-2" /> 0412 345 678
                </a>
              </div>
              <div className="mt-4 text-sm text-gray-400">This is a demo website for demonstration purposes only</div>
            </div>
            <div className="md:w-1/2">
              <div className="bg-white p-6 rounded-lg shadow-xl">
                <div className="bg-primary text-secondary p-4 -mt-10 rounded-lg shadow-lg max-w-xs mx-auto mb-4">
                  <p className="font-bold text-center pulse-animation">24/7 Emergency Service Available</p>
                </div>
                <img src="https://images.unsplash.com/photo-1621905251189-08b45d6a269e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80" 
                     alt="Electrician at work" 
                     className="rounded-lg w-full h-64 object-cover object-center" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Our Electrical Services</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We provide comprehensive electrical services for residential and commercial properties, ensuring safety and reliability.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Service 1 */}
            <div className="service-card bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="bg-primary p-4 flex justify-center">
                <FaHome className="text-4xl text-secondary" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3">Residential Services</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Electrical repairs & troubleshooting
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Lighting installation & upgrades
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Switchboard upgrades & replacements
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Ceiling fan installation
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Safety switch installation
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Service 2 */}
            <div className="service-card bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="bg-primary p-4 flex justify-center">
                <FaBuilding className="text-4xl text-secondary" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3">Commercial Services</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Commercial wiring & repairs
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Office lighting solutions
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Energy efficiency upgrades
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Equipment installation
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Code compliance checks
                  </li>
                </ul>
              </div>
            </div>
            
            {/* Service 3 */}
            <div className="service-card bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="bg-primary p-4 flex justify-center">
                <FaTools className="text-4xl text-secondary" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-3">Specialized Services</h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Electric vehicle charging stations
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Smart home automation
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Solar panel installation
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Surge protection
                  </li>
                  <li className="flex items-start">
                    <FaBolt className="text-primary mt-1 mr-2" /> Emergency power solutions
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="mt-12 text-center">
            <a href="#contact" className="bg-primary text-secondary font-bold py-3 px-8 rounded-lg shadow-lg hover:bg-yellow-500 transition inline-block cta-button">
              Schedule A Service
            </a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <img 
                src="https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80" 
                alt="Our team of electricians" 
                className="rounded-xl shadow-xl w-full h-96 object-cover object-center"
              />
            </div>
            <div className="md:w-1/2 md:pl-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-6">Why Choose PowerPro Electrical?</h2>
              
              <div className="space-y-6">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                      <FaHardHat className="text-secondary text-xl" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold">Licensed & Insured Professionals</h3>
                    <p className="mt-2 text-gray-600">Our team consists of fully licensed, insured, and certified electricians with years of experience in the Australian electrical industry.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                      <FaStar className="text-secondary text-xl" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold">100% Satisfaction Guarantee</h3>
                    <p className="mt-2 text-gray-600">We stand behind our work with a 100% satisfaction guarantee on all services we provide.</p>
                  </div>
                </div>
                
                <div className="flex">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                      <FaTools className="text-secondary text-xl" />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-semibold">State-of-the-Art Equipment</h3>
                    <p className="mt-2 text-gray-600">We use the latest tools and technology to ensure efficient and high-quality electrical work.</p>
                  </div>
                </div>
              </div>
              
              <div className="mt-8">
                <p className="text-gray-600">
                  Serving communities across Australia since 2005, PowerPro Electrical has established a reputation for excellence, reliability and superior customer service. We treat every job, big or small, with the same level of dedication and professionalism.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">What Our Clients Say</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Don't just take our word for it. Here's what our satisfied customers have to say about our services.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Testimonial 1 */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="text-primary">
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4">
                "The team at PowerPro Electrical was amazing. They arrived on time, fixed our electrical issues quickly, and left our home spotless. I highly recommend their services to anyone in Sydney!"
              </blockquote>
              <div className="font-semibold">
                - Emma Thompson, Homeowner
              </div>
            </div>
            
            {/* Testimonial 2 */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="text-primary">
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4">
                "As a café owner in Melbourne, I need reliable electrical services. PowerPro has been our go-to electrician for years. Their commercial services are unmatched in quality and value."
              </blockquote>
              <div className="font-semibold">
                - James Wilson, Business Owner
              </div>
            </div>
            
            {/* Testimonial 3 */}
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="text-primary">
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                  <FaStar className="inline" />
                </div>
              </div>
              <blockquote className="text-gray-700 mb-4">
                "I had an electrical emergency during a storm, and PowerPro responded within the hour. Their 24/7 emergency service is truly lifesaving. Professional and courteous technicians!"
              </blockquote>
              <div className="font-semibold">
                - Olivia Chen, Brisbane Resident
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Contact Us</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Have a question or ready to schedule a service? Reach out to us today and we'll be happy to help you with all your electrical needs.
            </p>
          </div>
          
          <div className="flex flex-col md:flex-row gap-12">
            <div className="md:w-1/2">
              <form onSubmit={handleSubmit} className="bg-gray-50 p-8 rounded-xl shadow-lg">
                <h3 className="text-2xl font-bold mb-6">Get In Touch</h3>
                
                <div className="mb-6">
                  <label htmlFor="name" className="block text-gray-700 mb-2">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    placeholder="Your name"
                  />
                </div>
                
                <div className="mb-6">
                  <label htmlFor="email" className="block text-gray-700 mb-2">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    placeholder="Your email"
                  />
                </div>
                
                <div className="mb-6">
                  <label htmlFor="phone" className="block text-gray-700 mb-2">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    placeholder="Your phone"
                  />
                </div>
                
                <div className="mb-6">
                  <label htmlFor="message" className="block text-gray-700 mb-2">How Can We Help?</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="4"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    placeholder="Describe your electrical needs"
                  ></textarea>
                </div>
                
                <button
                  type="submit"
                  className="w-full bg-primary text-secondary font-bold py-3 rounded-lg hover:bg-yellow-500 transition cta-button"
                >
                  Send Message
                </button>
              </form>
            </div>
            
            <div className="md:w-1/2">
              <div className="bg-secondary text-white p-8 rounded-xl shadow-lg h-full">
                <h3 className="text-2xl font-bold mb-6">Contact Information</h3>
                
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="bg-primary p-3 rounded-full mr-4">
                      <FaPhone className="text-secondary" />
                    </div>
                    <div>
                      <p className="font-semibold text-lg mb-1">Phone</p>
                      <a href="tel:+61412345678" className="text-gray-300 hover:text-primary">0412 345 678</a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="bg-primary p-3 rounded-full mr-4">
                      <FaEnvelope className="text-secondary" />
                    </div>
                    <div>
                      <p className="font-semibold text-lg mb-1">Email</p>
                      <a href="mailto:info@powerproelectrical.com.au" className="text-gray-300 hover:text-primary">info@powerproelectrical.com.au</a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="bg-primary p-3 rounded-full mr-4">
                      <FaMapMarkerAlt className="text-secondary" />
                    </div>
                    <div>
                      <p className="font-semibold text-lg mb-1">Office Location</p>
                      <address className="text-gray-300 not-italic">
                        42 Voltage Street<br />
                        Surry Hills, NSW 2010
                      </address>
                    </div>
                  </div>
                </div>
                
                <div className="mt-12">
                  <h4 className="font-semibold text-lg mb-4">Business Hours</h4>
                  <ul className="space-y-2 text-gray-300">
                    <li className="flex justify-between">
                      <span>Monday - Friday:</span>
                      <span>8:00 AM - 6:00 PM</span>
                    </li>
                    <li className="flex justify-between">
                      <span>Saturday:</span>
                      <span>9:00 AM - 3:00 PM</span>
                    </li>
                    <li className="flex justify-between">
                      <span>Sunday:</span>
                      <span>Closed</span>
                    </li>
                  </ul>
                  <p className="mt-4 font-semibold text-primary">24/7 Emergency Service Available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-secondary text-white py-12">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between mb-8">
            <div className="mb-8 md:mb-0">
              <div className="flex items-center mb-4">
                <FaBolt className="text-primary text-3xl mr-2" />
                <span className="font-bold text-2xl">PowerPro Electrical</span>
              </div>
              <p className="text-gray-400 max-w-xs">
                Your trusted partner for all residential and commercial electrical services.
              </p>
              <div className="mt-4 flex space-x-4">
                <a href="https://facebook.com/powerproelectricalau" className="text-gray-400 hover:text-primary transition" aria-label="Facebook">
                  <FaFacebook className="text-xl" />
                </a>
                <a href="https://twitter.com/powerproau" className="text-gray-400 hover:text-primary transition" aria-label="Twitter">
                  <FaTwitter className="text-xl" />
                </a>
                <a href="https://instagram.com" className="text-gray-400 hover:text-primary transition" aria-label="Instagram">
                  <FaInstagram className="text-xl" />
                </a>
                <a href="https://linkedin.com" className="text-gray-400 hover:text-primary transition" aria-label="LinkedIn">
                  <FaLinkedin className="text-xl" />
                </a>
              </div>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
              <div>
                <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
                <ul className="space-y-2">
                  <li><a href="#home" className="text-gray-400 hover:text-primary">Home</a></li>
                  <li><a href="#services" className="text-gray-400 hover:text-primary">Services</a></li>
                  <li><a href="#about" className="text-gray-400 hover:text-primary">About Us</a></li>
                  <li><a href="#testimonials" className="text-gray-400 hover:text-primary">Testimonials</a></li>
                  <li><a href="#contact" className="text-gray-400 hover:text-primary">Contact</a></li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-lg font-semibold mb-4">Services</h3>
                <ul className="space-y-2">
                  <li><a href="#services" className="text-gray-400 hover:text-primary">Residential</a></li>
                  <li><a href="#services" className="text-gray-400 hover:text-primary">Commercial</a></li>
                  <li><a href="#services" className="text-gray-400 hover:text-primary">Emergency</a></li>
                  <li><a href="#services" className="text-gray-400 hover:text-primary">Installations</a></li>
                  <li><a href="#services" className="text-gray-400 hover:text-primary">Repairs</a></li>
                </ul>
              </div>
              
              <div className="col-span-2 md:col-span-1">
                <h3 className="text-lg font-semibold mb-4">Contact</h3>
                <ul className="space-y-2">
                  <li className="flex items-start">
                    <FaPhone className="text-primary mt-1 mr-2" />
                    <span className="text-gray-400">0412 345 678</span>
                  </li>
                  <li className="flex items-start">
                    <FaEnvelope className="text-primary mt-1 mr-2" />
                    <span className="text-gray-400">info@powerproelectrical.com.au</span>
                  </li>
                  <li className="flex items-start">
                    <FaMapMarkerAlt className="text-primary mt-1 mr-2" />
                    <span className="text-gray-400">42 Voltage Street, Surry Hills, NSW 2010</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <div className="pt-8 border-t border-gray-800 text-center text-gray-500">
            <p className="mb-2"><strong>DEMO WEBSITE:</strong> This is a sample website created for demonstration purposes only.</p>
            <p className="mb-4">Built by <a href="https://cloudnext.dev" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">CloudNext</a> - Australian app & website development agency.</p>
            
            <div className="my-4">
              <p className="mb-2 text-sm">Other projects by CloudNext:</p>
              <div className="flex justify-center space-x-6">
                <a href="https://peakk.net" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline text-sm">
                  Peakk Health App
                </a>
                <a href="http://ulitimatedirectory.net" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline text-sm">
                  Ultimate Directory
                </a>
              </div>
            </div>
            
            <p>&copy; {new Date().getFullYear()} CloudNext - PowerPro Electrical Demo. All rights reserved.</p>
            <p className="mt-2 text-sm">This is a fictional business for demonstration purposes only.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
